import { render, staticRenderFns } from "./ProductsContainer.vue?vue&type=template&id=21bc180f&"
import script from "./ProductsContainer.vue?vue&type=script&lang=js&"
export * from "./ProductsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports